// topic-metadata.js
export default {
  stardewvalley: {
    // Basic SEO
    title: "Stardew Valley Community | Therize",
    description: "Connect with fellow farmers, share your farm designs, and discover the latest Stardew Valley mods and strategies. Join our active community of Stardew Valley enthusiasts.",
    keywords: "stardew valley, farming game, pixel art, indie game, community, farm designs, mods, strategies, multiplayer, pelican town, crops, animals, mining, fishing, relationships",
    
    // Open Graph / Social
    ogImage: "stardewvalley-social.jpg",
    ogType: "website",
    twitterCard: "summary_large_image",
    
    // Additional SEO metadata
    canonical: "https://stardewvalley.therize.net",
    locale: "en_US",
    themeColor: "#64ffda",
    
    // Structured data enhancements
    structuredData: {
      "@type": "WebSite",
      additionalType: "GameWebsite",
      genre: "Farming Simulation",
      gameCategory: "Indie Game",
      audience: {
        "@type": "Audience",
        audienceType: "Gamers",
        geographicArea: "Global"
      },
      offers: {
        "@type": "Offer",
        availability: "https://schema.org/InStock",
        price: "0",
        priceCurrency: "USD"
      }
    }
  },
  
  fortnite: {
    // Basic SEO
    title: "Fortnite Community Hub | Therize",
    description: "Stay updated on Fortnite events, share gameplay strategies, and connect with other players. Get the latest news on seasons, skins, and competitive tournaments.",
    keywords: "fortnite, battle royale, gaming, epic games, fortnite events, gameplay strategies, building tips, skins, emotes, seasons, battle pass, competitive fortnite, tournaments, victory royale",
    
    // Open Graph / Social
    ogImage: "fortnite-social.jpg",
    ogType: "website",
    twitterCard: "summary_large_image",
    
    // Additional SEO metadata
    canonical: "https://fortnite.therize.net",
    locale: "en_US",
    themeColor: "#5dabf4",
    
    // Structured data enhancements
    structuredData: {
      "@type": "WebSite",
      additionalType: "GameWebsite",
      genre: "Battle Royale",
      gameCategory: "Action Game",
      audience: {
        "@type": "Audience",
        audienceType: "Gamers",
        geographicArea: "Global"
      },
      offers: {
        "@type": "Offer",
        availability: "https://schema.org/InStock",
        price: "0",
        priceCurrency: "USD"
      }
    }
  },
  
  // Default fallback
  default: {
    // Basic SEO
    title: "Therize Community",
    description: "Connect, share, and explore with like-minded individuals in our vibrant online community.",
    keywords: "community, social, connect, share, online community, discussion, forum, networking",
    
    // Open Graph / Social
    ogImage: "default-social.jpg",
    ogType: "website",
    twitterCard: "summary_large_image",
    
    // Additional SEO metadata
    canonical: "https://therize.net",
    locale: "en_US",
    themeColor: "#64ffda",
    
    // Structured data enhancements
    structuredData: {
      "@type": "WebSite",
      additionalType: "SocialMediaPosting",
      audience: {
        "@type": "Audience",
        audienceType: "Internet Users",
        geographicArea: "Global"
      }
    }
  }
};
